export const fonts = {
	fontFamily: 'futura-pt',
	fontFamilyTitle: 'futura-pt',
}
